/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_Req_R4Inputs */

const en_fc_online_req_r4 = /** @type {(inputs: Fc_Online_Req_R4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save and Export arrive as browser downloads; preferences live in local storage.`)
};

/**
* | output |
* | --- |
* | "Save and Export arrive as browser downloads; preferences live in local storage." |
*
* @param {Fc_Online_Req_R4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_req_r4 = /** @type {((inputs?: Fc_Online_Req_R4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_Req_R4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_req_r4(inputs)
});
export { fc_online_req_r4 as "fc.online.req.r4" }